$(document).ready(function () {
  if (window.location.href === "https://evolvegamingpc.com.au/products/cables-live?variant=49262960083218") {
    const $btn = $('#AddToCart');
    if ($btn.length) {
      $btn.replaceWith($btn.clone());
    }

    const $sticky = $('.sticky-btn');
    if ($sticky.length) {
      $sticky.removeAttr('disabled')
        .css({
          opacity: 1,
          cursor: 'pointer'
        });

      $sticky.on('click', function () {
        $('#AddToCart').trigger('click');
      });
    }
  }

  //add option value for OLYMPUS PRODUCT 
  const moveYmqOption = setInterval(function () {
    const $gpuOption = $('#ymq-box .ymq-options-box.ymq-options-box-3');
    const $systemOption = $('#features-wrapper #option-box-ymq-variant-0');

    if ($gpuOption.length && $systemOption.length) {
      $gpuOption.insertAfter($systemOption);
      clearInterval(moveYmqOption);
    }
  }, 300);


  $('#StickyAddToCart').on('click', function (e) {
    e.preventDefault();
    $('#AddToCart').trigger('click');
  });

  //source code for update price on the sticky footer
  // Function to get the current price HTML from the main price area
  function getCurrentPriceHtml() {
    // Replace '.price.price--large' with the correct selector for your main price area
    var mainPrice = $('.product-meta__price-list-container .price.price--large').html();
    return mainPrice ? mainPrice : '';
  }

  // Function to update the sticky price
  function updateStickyPrice() {
    var priceHtml = getCurrentPriceHtml();

    var $stickyFooterPrice = $('.prostickyfooter .right-price');
    if ($stickyFooterPrice.length) {
      $stickyFooterPrice.html(priceHtml);
    }

    var $stickyFormPrice = $('.product-sticky-form__inner .product-sticky-form__price');
    if ($stickyFormPrice.length) {
      $stickyFormPrice.html(priceHtml);
    }
  }
  //end source code for update price on the sticky footer

  // Listen for changes on variant/option selectors
  $(document).on('change', 'select, input', function (e) {
    setTimeout(updateStickyPrice, 200); // Wait for the app to update the main price before getting it
  });

  // It will run when "Enhanced Dropdown" setup is switched to "on" in the YMQ app.
  $(document).on('click', '.ymq-dropdown ul li', function () {
    setTimeout(updateStickyPrice, 200);
  });

  // Initial update when the page loads
  updateStickyPrice();

  //custom text for ymq app
  setTimeout(function () {
    const labelMap = {
      'Colour Case': 'Colour Case',
      // 'Storage': 'Add Storage',
      'CPU': 'Change CPU',
      'GPU': 'Change GPU',
      'PSU': 'Change PSU',
      'RAM': 'Change RAM'
    };

    $('.fgc-custom-ymq-1 .ymq_lable').each(function () {
      const currentText = $(this).text().trim();
      if (labelMap[currentText]) {
        $(this).text(labelMap[currentText]);
      }
    });
  }, 100);

  setTimeout(function () {
    const labelMap = {
      // 'Storage Display': 'Storage ',
      'GPU Display': 'GPU',
      'CPU Intel': 'CPU',
      'CPU AMD': 'CPU',
      'Motherboard Display': 'Motherboard',
      'RAM Display': 'RAM',
      'PSU Display': 'PSU',
    };

    $('.fgc-custom-ymq-2 .ymq_lable').each(function () {
      const currentText = $(this).text().trim();
      if (labelMap[currentText]) {
        $(this).text(labelMap[currentText]);
      }
    });
  }, 100); // delay wait ymq app render
  //end custom text for ymq app

  // move 
  setTimeout(function () {
    $('.fgc-custom-ymq-variants').insertBefore('.fgc-custom-system-position');
  }, 300);

  //ko biết mở cái này nó có ảnh hưởng gì tới site ko
  setTimeout(function () {
    // if ($('.option-box-ymq-variant-0').length > 0) {
    if ($('#ymq-box .ymq-options-box').length > 0) {
      setTimeout(function () {
        $('.fgc-custom__separation').insertBefore('.fgc-custom-ymq-variants').show();
      }, 300);
    } else {
      $('.fgc-custom__separation').hide();
    }
  }, 100);

  setTimeout(function () {
    $('.ymq-shopify-option-box').addClass('fgc-custom-ymq-1');
    $('.ymq-shopify-option-box').insertAfter('.ymq-options-box[ymq-option-label="OS"]');
  }, 100);
  const interval = setInterval(function () {
    const $separation = $('.fgc-custom__separation');
    const $target = $('.ymq-shopify-option-box');

    if ($separation.length && $target.length) {
      $separation.insertBefore($target);
      clearInterval(interval);
    }
  }, 100);

});

// Ensure ymq box sits AFTER the custom tabs (matches live)
(function () {
  function moveYmqAfterTabs() {
    var ymqBox = document.querySelector('#ymq-box');
    var tab2 = document.querySelector('#custom-tab-2');
    if (!ymqBox || !tab2) return false;

    if (ymqBox.previousElementSibling !== tab2) {
      tab2.insertAdjacentElement('afterend', ymqBox);
    }
    return true;
  }

  if (moveYmqAfterTabs()) return;

  var observer = new MutationObserver(function () {
    if (moveYmqAfterTabs()) {
      observer.disconnect();
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();

document.addEventListener("DOMContentLoaded", function () {
  const keywords = ["CPU", "GPU", "RAM", "Cooler", "Case", "PSU", "OS", "Motherboard"];
  const targetId = "extra-product-detail";

  function checkAndShowExtraDetail() {
    const optionBoxes = document.querySelectorAll('#ymq-box .ymq-options-box');

    for (let box of optionBoxes) {
      const label = box.getAttribute('data-label');
      if (label && keywords.includes(label.trim())) {
        const extraDetail = document.getElementById(targetId);
        if (extraDetail) {
          extraDetail.style.display = "block";
          return true;
        }
      }
    }
    return false;
  }

  const interval = setInterval(() => {
    const isVisible = checkAndShowExtraDetail();
    if (isVisible) clearInterval(interval);
  }, 200);

  setTimeout(() => clearInterval(interval), 10000);
});


//update compare-at-price
let lastTotal = null;

function moneyFormat(amount) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD"
  }).format(amount);
}

function getBaseCompareValue() {
  const baseEl =
    document.querySelector('.fgc-custom-compare-price') ||
    document.querySelector('.fgc-custom-compare-price-mobile');
  if (!baseEl) return null;
  return parseFloat((baseEl.textContent || '').replace(/[^0-9.]/g, '')) || 0;
}

function getYmqOptionTotal() {
  const optionEls = document.querySelectorAll('.ymq-option-addon-price .ymq-price-span');
  let total = 0;
  optionEls.forEach(el => {
    const v =
      parseFloat(el.getAttribute('data-ymq-money')) ||
      parseFloat((el.textContent || '').replace(/[^0-9.]/g, '')) ||
      0;
    total += v;
  });
  return total;
}

function updateFgcCompare() {
  const baseValue = getBaseCompareValue();
  if (baseValue === null) return;

  const optionTotal = getYmqOptionTotal();
  const newTotal = baseValue + optionTotal;

  if (newTotal !== lastTotal) {
    lastTotal = newTotal;

    document.querySelectorAll('.fgc-add-new-compare-price, .fgc-add-new-compare-price-mobile')
      .forEach(t => (t.textContent = moneyFormat(newTotal)));
  }
}

updateFgcCompare();
setInterval(updateFgcCompare, 200);

//end update compare-at-price


// custom for h1 subtitle
(function () {
  var subtitle = document.querySelector('[data-ymq-subtitle]');
  if (!subtitle) return;

  // Hide by default; show only when #ymq-box exists
  subtitle.style.display = 'none';

  function showIfYmqExists() {
    if (document.querySelector('#ymq-box .ymq-options-box')) {
      subtitle.style.display = '';
      return true;
    }
    return false;
  }

  if (!showIfYmqExists()) {
    var observer = new MutationObserver(function () {
      if (showIfYmqExists()) {
        observer.disconnect();
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();


// end custom for h1 subtitle
